import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useToast } from "./Toast";
const LanguageModal = ({ kiosk, isOpen, onClose, onSave }) => {
  const Toast = useToast();
  const languages = kiosk.languages;
  const kioskId = kiosk._id;

  const allLanguages = [
    { title: "हिंदी", value: "hindi" },
    { title: "मराठी", value: "marathi" },
    { title: "தமிழ்", value: "tamil" },
    { title: "తెలుగు", value: "telugu" },
    { title: "ಕನ್ನಡ", value: "kannada" },
    { title: "ગુજરાતી", value: "gujarati" },
    { title: "മലയാളം", value: "malayalam" },
    { title: "عربي", value: "arabic" },
    { title: "ਪੰਜਾਬੀ", value: "punjabi" },
    { title: "ଓଡିଆ", value: "odia" },
    { title: "বাংলা", value: "bengali" },
    { title: "অসমীয়া", value: "Assamese" },
    { title: "اردو", value: "urdu" },
    { title: "日本語", value: "japanese" },
  ];
  const token = localStorage.getItem("token");
  const [selectedLanguages, setSelectedLanguages] = useState([]);

  useEffect(() => {
    if (isOpen) {
      const selectedValues = languages.map((lang) => ({
        title: lang.title,
        value: lang.value,
      }));

      setSelectedLanguages(selectedValues);
    }
  }, [isOpen, languages]);

  const handleCheckboxChange = (lang) => {
    setSelectedLanguages((prev) => {
      const exists = prev.some((l) => l.value === lang.value);
      if (exists) {
        return prev.filter((l) => l.value !== lang.value);
      } else {
        return [...prev, lang];
      }
    });
  };

  const handleSave = async () => {
    const payload = {
      _id: kioskId,
      languages: selectedLanguages,
    };
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST_URL}/ops/v1/kiosks/update`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update languages");
      }

      kiosk.kioskLanguages = selectedLanguages;
      Toast.success("Languages saved successfully!");
      return true;
    } catch (e) {
      console.error("Error", e);
      Toast.error("An error occurred while submitting Languages!");
      return false;
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: { borderRadius: 3, p: 2, maxHeight: "80vh" },
      }}
    >
      <DialogTitle>
        <Typography variant="h6" fontWeight="bold">
          Select Languages
        </Typography>
      </DialogTitle>

      <DialogContent dividers sx={{ overflowY: "auto" }}>
        {allLanguages.map((lang) => (
          <Box
            key={lang.value}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            py={1}
          >
            <Box>
              <Typography fontWeight="medium">{lang.value}</Typography>
              <Typography variant="caption" color="text.secondary">
                {lang.title}
              </Typography>
            </Box>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedLanguages.some(
                    (l) => l.value === lang.value
                  )}
                  onChange={() => handleCheckboxChange(lang)}
                  sx={{
                    color: "purple",
                    "&.Mui-checked": {
                      color: "purple",
                    },
                  }}
                />
              }
              label=""
            />
          </Box>
        ))}
      </DialogContent>

      <DialogActions>
        <Button
          onClick={async () => {
            const success = await handleSave();
            if (success && onClose) onClose();
            if (success && onSave) onSave();
          }}
          variant="contained"
          color="primary"
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LanguageModal;
